module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-8"
  }, [_c('div', {
    staticClass: "card card-default widget animated"
  }, [_c('div', {
    staticClass: "card-heading"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditing),
      expression: "!isEditing"
    }],
    staticClass: "mobileDeviceViewing"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "font-size": "35px"
    }
  }, [_vm._v(_vm._s(_vm.mobileDevice.name))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('p', [_vm._v("MDM Device ID: " + _vm._s(_vm.mobileDevice.mdm_device_id != null ? _vm.mobileDevice.mdm_device_id : "Not Set") + "\n                  ")]), _c('p', [_vm._v(_vm._s(_vm.mobileDevice.assigned == true ? 'Device has been assigned' : "Device hasn't been assigned"))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.mobileDevice.chat == true ? 'Wire is Enabled' : 'Wire is Disabled'))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.org['curOrg']['role'] == 99) ? _c('button', {
    staticClass: "btn  btn-default form-group",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info form-group",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#showQRCodeModal"
    }
  }, [_vm._v("ShowQRCode")])]), _vm._v(" "), (_vm.mobileDevice.mdm_device_id != null) ? _c('div', {
    staticClass: "col-md-5"
  }, [(!_vm.showMdmDeviceData) ? _c('div', [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fetchMDMDeviceData
    }
  }, [_vm._v("Show MDM Data")])]) : _c('div', [(_vm.mdmDeviceData.device) ? _c('div', [_c('p', [_vm._v("Device Name: " + _vm._s(_vm.mdmDeviceData.device.device_name))]), _vm._v(" "), _c('p', [_vm._v("OS Version: " + _vm._s(_vm.mdmDeviceData.device.os_name) + " " + _vm._s(_vm.mdmDeviceData.device.os_version))]), _vm._v(" "), _c('p', [_vm._v("Last Battery Level: " + _vm._s(Math.round(_vm.mdmDeviceData.device.battery_level)) + "%")]), _vm._v(" "), _c('p', [_vm._v("Last Seen: " + _vm._s(new Date(_vm.mdmDeviceData.lastreported).toLocaleString()))])]) : (_vm.mdmDeviceData.error) ? _c('div', [_c('p', [_vm._v("MDM Data Error: " + _vm._s(_vm.mdmDeviceData.error.message))]), _vm._v(" "), _c('p', [_vm._v("Are you sure the MDM Device ID is correct?")])]) : _c('div', [_c('stretch-loading')], 1)])]) : _vm._e()])])]), _vm._v(" "), (_vm.org['curOrg']['role'] == 99) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditing),
      expression: "isEditing"
    }],
    staticClass: "mobileDeviceEditing col-md-5"
  }, [_c('form-text', {
    ref: "name",
    attrs: {
      "styler": "font-size:35px",
      "label": "Name",
      "name": "name",
      "validation": "required"
    },
    model: {
      value: (_vm.mobileDeviceEdit.name),
      callback: function($$v) {
        _vm.$set(_vm.mobileDeviceEdit, "name", $$v)
      },
      expression: "mobileDeviceEdit.name"
    }
  }), _vm._v(" "), _c('form-text', {
    attrs: {
      "label": "MDM Device ID",
      "name": "mdm_device_id"
    },
    model: {
      value: (_vm.mobileDeviceEdit.mdm_device_id),
      callback: function($$v) {
        _vm.$set(_vm.mobileDeviceEdit, "mdm_device_id", $$v)
      },
      expression: "mobileDeviceEdit.mdm_device_id"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', [_vm._v("Wire")]), _vm._v(" "), _c('form-checkbox', {
    attrs: {
      "label": "Wire",
      "name": "chat"
    },
    model: {
      value: (_vm.mobileDevice.chat),
      callback: function($$v) {
        _vm.$set(_vm.mobileDevice, "chat", $$v)
      },
      expression: "mobileDevice.chat"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn  btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn  btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitEdit
    }
  }, [_vm._v("Submit")]), _vm._v(" "), (_vm.mobileDevice.assigned == true) ? _c('button', {
    staticClass: "btn btn-warning form-group rightey",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#unassignDeviceModal"
    }
  }, [_vm._v("Unassign Device")]) : _vm._e()])], 1) : _vm._e()])])])]), _vm._v(" "), _c('showqrcode', {
    attrs: {
      "deviceid": _vm.mobileDevice['.key'],
      "name": "showQRCodeModal"
    }
  }), _vm._v(" "), _c('unassigndevice', {
    attrs: {
      "name": "unassignDeviceModal"
    },
    on: {
      "unassignDevice": _vm.unassignDevice
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e1524dd6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Devices/MobileDevice/EditMobileDevice.vue
// module id = 666
// module chunks = 1